import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import { SubmissionsModalDeleteIcon } from '../../svgs';
import { VpButton, VpDialogActions, VpIcon, VpDialogTitle, VpDialogContent } from '../../';

import { StyledStack } from './styles';

const VpDeleteDialog = ({
  open = false,
  type = '',
  shouldCloseOnDelete = false,
  loading = false,
  onDelete = null,
  onClose = null,
  onCancel = null
}) => {
  const handleCancel = () => {
    onClose && onClose();
    onCancel && onCancel();
  };
  const handleDelete = () => {
    onDelete && onDelete();
    if (shouldCloseOnDelete) {
      onClose && onClose();
    }
  };
  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs">
      <VpDialogTitle leftContent={`Delete ${type}`} onClose={onClose} />
      <VpDialogContent>
        <Stack justifyItems="center" alignItems="center" spacing="20px">
          <SubmissionsModalDeleteIcon />
          <Typography variant="dialogBody2">
            Are you sure you want to delete? This action cannot be undone.
          </Typography>
          <VpDialogActions fullWidth>
            <StyledStack direction="row" justifyContent="space-between">
              <VpButton
                color="neutral"
                variant="contained"
                onClick={handleCancel}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} /> : null}
              >
                Cancel
              </VpButton>
              <VpButton
                disabled={loading}
                variant="contained"
                onClick={handleDelete}
                startIcon={
                  loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : (
                    <VpIcon icon="Trash2" />
                  )
                }
              >
                Delete {type}
              </VpButton>
            </StyledStack>
          </VpDialogActions>
        </Stack>
      </VpDialogContent>
    </Dialog>
  );
};

VpDeleteDialog.propTypes = {
  open: PropTypes.bool,
  shouldCloseOnDelete: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.string,
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func
};

export default VpDeleteDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpDeleteDialog/VpDeleteDialog.jsx